function descontructDate (date) {
    const y = date.getFullYear();
    const m = date.getMonth() + 1;
    const d = date.getDate();
    const h = date.getHours();
    const i = date.getMinutes();
    const s = date.getSeconds();

    return [y, m, d, h, i, s].map( t => t >= 10 ? `${t}` : `0${t}` );
}

function dateToYMDHi (date) {
    const [y, m, d, h, i, ] = descontructDate(date);
    return `${y}-${m}-${d} ${h}:${i}`;
}

function dateToYMD (date) {
    const [y, m, d, ] = descontructDate(date);
    return `${y}-${m}-${d}`;    
}

function copyObj (obj) {
    return JSON.parse(JSON.stringify(obj))
}

export default {
    dateToYMDHi,
    dateToYMD,
    copyObj
}